'use strict';exports.__esModule = true;exports.isRussianChar = exports.isEnglishChar = exports.isHebrewChar = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Consts
var translateUrl = _constants.googleSdkConfig.translateUrl,apiKey = _constants.googleSdkConfig.apiKey;
var baseDetectUrl = translateUrl + '/detect?key=' + apiKey + '&q=';

var escapeDetectSymbols = ['\n', '%'].
map(function (from) {return { from: from, to: '' };});

var escapeRecievedTextSymbols = [
{ from: '&amp;', to: '&' },
{ from: '&#39;', to: '\'' }];


// TODO: Should be dynamic from consts
var isHebrewChar = exports.isHebrewChar = function isHebrewChar(char) {return (/[\u0590-\u05fe]/.test(char));};
var isEnglishChar = exports.isEnglishChar = function isEnglishChar(char) {return (/[a-zA-Z]/.test(char));};
var isRussianChar = exports.isRussianChar = function isRussianChar(char) {return (/[а-яА-Я]/.test(char));};

var langToRegexp = {
  he: isHebrewChar,
  en: isEnglishChar,
  ru: isRussianChar };


var calculateLanguageProbability = function calculateLanguageProbability(charArray) {return (
    charArray.reduce(function (acc, char) {
      if (isHebrewChar(char)) {
        acc.he += 1;
      }
      if (isEnglishChar(char)) {
        acc.en += 1;
      }
      if (isRussianChar(char)) {
        acc.ru += 1;
      }

      return acc;
    }, { en: 0, he: 0, ru: 0 }));};

// Private
var escapeStringWithSymbols = function escapeStringWithSymbols(string, symbols) {return (
    symbols.reduce(function (text, _ref) {var from = _ref.from,to = _ref.to;return (
        text.replace(new RegExp(from, 'g'), to));}, string));};

var formatDescriptionQuery = function formatDescriptionQuery(text) {return text.
  split('\n').
  reduce(function (res, row) {return res + 'q=' + encodeURIComponent(row) + '&';}, '').
  slice(0, -1);};

var formatString = function formatString(string) {return string.split('').filter(function (char) {return !!char.trim();});};

var formatReceivedText = function formatReceivedText() {var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return escapeStringWithSymbols(text, escapeRecievedTextSymbols);};

var createTranslateUrl = function createTranslateUrl(string, target, source) {return translateUrl + ['?key=' +
  apiKey, 'source=' +
  source, 'target=' +
  target,
  formatDescriptionQuery(string)].
  join('&');};

// Public
exports.default = {
  detect: function detect(string) {
    var escapedText = escapeStringWithSymbols(string, escapeDetectSymbols);
    return _axios2.default.get(baseDetectUrl + decodeURIComponent(escapedText));
  },
  suggestStringLanguage: function suggestStringLanguage() {var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';var minProbability = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
    return new Promise(function (resolve, reject) {
      try {
        if (!str || typeof str === 'string' && !str.trim().length) {
          return reject(new Error('String not provided'));
        }

        // Remove all spaces between word to get only characters
        var formattedString = formatString(str);
        var calc = calculateLanguageProbability(formattedString);
        var result = Object.keys(calc).map(function (key) {return {
            language: key,
            probability: calc[key] / formattedString.length };});


        return resolve(result.find(function (item) {return item.probability >= minProbability;}));
      } catch (error) {
        return reject(error);
      }
    });
  },
  translate: function translate(string, target, source) {
    return new Promise(function (resolve, reject) {return _axios2.default.get(createTranslateUrl(string, target, source)).
      then(function (_ref2) {var translations = _ref2.data.data.translations;return resolve(
        translations.reduce(function (acc, row, idx) {return '' + (
          acc + formatReceivedText(row.translatedText)) + (translations.length - 1 !== idx ? '\n' : '');},
        ''));}).

      catch(reject);});
  },
  containCharsExcept: function containCharsExcept(string) {for (var _len = arguments.length, langs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {langs[_key - 1] = arguments[_key];}
    var formattedString = formatString(string);
    return formattedString.some(function (char) {return !langs.some(function (lang) {return langToRegexp[lang](char);});});
  } };


//////////////////
// WEBPACK FOOTER
// ./src/services/TranslationService.js
// module id = 1273
// module chunks = 0